// extracted by mini-css-extract-plugin
export var li = "_uj-2";
export var ol = "_uj-1";
export var ul = "_uj-0";